import { axiosBase, errorHandler } from './axios';

const saveQuery = (data: any) => {
  return axiosBase.post('query/save', data)
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

const listQueries = (params: any) => {
  return axiosBase.get('query/list', { params })
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

const viewQuery = (id: string) => {
  return axiosBase.get(`query/view/${id}`)
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

const deleteQuery = (id: string) => {
  return axiosBase.delete(`query/delete/${id}`)
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

const addRemarks = (id: string, remarks: string) => {
  return axiosBase.post(`query/remarks/${id}`, { remarks })
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

export const queryService = {
  saveQuery,
  listQueries,
  viewQuery,
  deleteQuery,
  addRemarks
};
